module.exports = __webpack_public_path__ + "static/img/pinpai-12.2e577caa.png";